import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {
  StyledInvoicePreview,
  StyledInvoicePreviewIcon,
} from './StyledInvoicePreview';
import {Space, Tooltip} from 'antd';
import ImagePreviewTooltip from '../../TransactionsPage/ImagePreviewTooltip';
import useInvoiceAttachmentPreview from '../../../../hooks/useInvoiceAttachmentPreview';
import {DownloadIcon, EyeIcon} from '../../../../icons';
import {firebaseEvents} from '../../../../snippets/firebase';
import {invoicesActions} from '../../../../state/actions/invoice.actions';
import invoicePlaceholderImg from '../../../../static/images/pages/transactions/invoice-placeholder.png';
import {amountHelpers, dateHelpers, fileHelpers, systemHelpers} from '../../../../utils/helpers';


const InvoicePreview = ({
  dispatch,
  downloadInvoice,
  invoice,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const {
    showPreview,
    tooltipContent
  } = useInvoiceAttachmentPreview();

  const handleOnDownloadClick = (e, id) => {
    e.preventDefault();

    if (!id) return;
    downloadInvoice(
      id,
      (data) => {
        fileHelpers.saveFile(data);
        systemHelpers.logEvent(firebaseEvents.INVOICES_DOWNLOAD_INVOICE);
      }
    );
  }

  const handleOnPreviewClick = (e, id) => {
    e.preventDefault();

    if (!id) return;
    showPreview(id);
  }

  const { id: invoiceId, vendor, amount = 0, date: invoiceDate } = invoice;

  const date = invoiceDate ? dateHelpers.getDateWithMonth(dateHelpers.getTimestampDateObject(invoiceDate), 'DD MMM YYYY') : '';

  return (
    <StyledInvoicePreview size='small' {...rest}>
      <Space size='small' align='center'>
        <img
          alt='invoice placeholer'
          className='placeholder'
          src={invoicePlaceholderImg}
        />
        <Space size={4} direction='vertical'>
          <span className='vendor'>
            {vendor}
          </span>
          <span className='date'>
            {date}
          </span>
        </Space>
      </Space>
      <Space direction='vertical' size={2} align='end'>
        <Space size='middle' className='invoice-preview-title'>
          <Space size={4}>
            <ImagePreviewTooltip
              classNames={{root: 'image-preview-tooltip-overlay transaction-details'}}
              title={tooltipContent}
              trigger='click'
            >
              <Tooltip title={t('preview')}>
                <StyledInvoicePreviewIcon onClick={(e) => handleOnPreviewClick(e, invoiceId)}>
                  <EyeIcon />
                </StyledInvoicePreviewIcon>
              </Tooltip>

            </ImagePreviewTooltip>
            <Tooltip title={t('download')}>
              <StyledInvoicePreviewIcon onClick={(e) => handleOnDownloadClick(e, invoiceId)}>
                <DownloadIcon />
              </StyledInvoicePreviewIcon>
            </Tooltip>
          </Space>
        </Space>

        <Space size='small'>
          <span className='price'>
            {amountHelpers.getAmountWithCurrencyCode(amount)}
          </span>
        </Space>
      </Space>
    </StyledInvoicePreview>
  );
}

InvoicePreview.propTypes = {
  invoice: PropTypes.object.isRequired,
}

const mapDispatchToProps = {
  downloadInvoice: invoicesActions.downloadInvoice,
}

export default connect(null, mapDispatchToProps)(InvoicePreview);
